export const lastUpdateDate = '10.06'